import { render, staticRenderFns } from "./colorVariantMixin.vue?vue&type=template&id=4b87898c"
import script from "./colorVariantMixin.vue?vue&type=script&lang=js"
export * from "./colorVariantMixin.vue?vue&type=script&lang=js"
import style0 from "./colorVariantMixin.vue?vue&type=style&index=0&id=4b87898c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports